var _circle, _circle2, _circle3, _rect, _rect2, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNeutralEmojiRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#ED2E54"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "white",
    fillOpacity: 0.48
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    stroke: "#ED2E54"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(12 12)",
    fill: "#ED2E54"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    transform: "translate(12 12)",
    fill: "white",
    fillOpacity: 0.48
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 42.5C29.1716 42.5 28.5 43.1716 28.5 44C28.5 44.8284 29.1716 45.5 30 45.5H42C42.8284 45.5 43.5 44.8284 43.5 44C43.5 43.1716 42.8284 42.5 42 42.5H30Z",
    fill: "#ED2E54"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32 31C32 32.6569 30.6569 34 29 34C27.3431 34 26 32.6569 26 31C26 29.3431 27.3431 28 29 28C30.6569 28 32 29.3431 32 31Z",
    fill: "#ED2E54"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 34C44.6569 34 46 32.6569 46 31C46 29.3431 44.6569 28 43 28C41.3431 28 40 29.3431 40 31C40 32.6569 41.3431 34 43 34Z",
    fill: "#ED2E54"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56 36C56 47.0457 47.0457 56 36 56C24.9543 56 16 47.0457 16 36C16 24.9543 24.9543 16 36 16C47.0457 16 56 24.9543 56 36ZM53 36C53 45.3888 45.3888 53 36 53C26.6112 53 19 45.3888 19 36C19 26.6112 26.6112 19 36 19C45.3888 19 53 26.6112 53 36Z",
    fill: "#ED2E54"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNeutralEmojiRed);
export default __webpack_public_path__ + "static/media/neutralEmojiRed.677fe17facc947b94fcac790d81fd6a5.svg";
export { ForwardRef as ReactComponent };